import { OrderDateTimeController } from '../controllers/orderDateTimeController';
import templateUrl from './orderDateTime.html';

export function OrderDateTimeDirective() {
    return {
        replace: true,
        templateUrl,
        scope: {},
        bindToController: true,
        controllerAs: 'vm',
        controller: OrderDateTimeController,
        transclude: {
            prependIfTimesAvailable: '?prependIfTimesAvailable',
            appendIfTimesAvailable: '?appendIfTimesAvailable'
        }
    };
}
